import React, { useEffect, useState } from 'react';
import SellerDashboard from 'views/SellerDashboard';
import { generateSellerReferralCode, getSellerSummary } from 'services/seller.services';

const SellerDashboardContainer = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generatingCode, setGeneratingCode] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getSellerSummary()
      .then((response) => setSummary(response))
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, []);

  const onGenerateCode = async () => {
    setGeneratingCode(true);
    setError('');
    try {
      const response = await generateSellerReferralCode();
      setSummary((previous) => ({ ...previous, ...response }));
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setGeneratingCode(false);
    }
  };

  return (
    <SellerDashboard
      error={error}
      generatingCode={generatingCode}
      loading={loading}
      onGenerateCode={onGenerateCode}
      summary={summary}
    />
  );
};

export default SellerDashboardContainer;
